/** GBP formatter for public price display. */

export function gbp(amount: number, opts: { decimals?: number } | number = {}): string {
  const decimals = typeof opts === "number" ? opts : (opts.decimals ?? 0);
  return amount.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
